var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5607 5.81259C8.5607 5.31958 8.96036 4.91992 9.45336 4.91992H17.0279C17.5209 4.91992 17.9205 5.31958 17.9205 5.81259V13.3871C17.9205 13.8801 17.5209 14.2798 17.0279 14.2798C16.5349 14.2798 16.1352 13.8801 16.1352 13.3871V7.96767L6.29731 17.8056C5.94871 18.1542 5.3835 18.1542 5.03489 17.8056C4.68629 17.457 4.68629 16.8918 5.03489 16.5432L14.8728 6.70525H9.45336C8.96036 6.70525 8.5607 6.30559 8.5607 5.81259Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSvg);
export default __webpack_public_path__ + "static/media/arrow-svg.c3d18ff78986f0af4c14b3ad44591e91.svg";
export { ForwardRef as ReactComponent };